import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent implements OnInit {
  @Input() state!:boolean;
  @Input() stateText!: string;

  ngOnInit(): void {
    this.state = false
  }
}
